import React from "react";
import { useTheme } from "@mui/material/styles";
import { BarChart } from "@mui/x-charts";

import {
  defaultColorPalette,
  getCartesianChartData,
  cartesianChartStyling,
} from "./utils";
import { useMediaQuery } from "@mui/material";

interface BarGraphProps {
  children?: React.ReactNode;
  content: Array<{ [key: string]: any }>;
  xAxisKey: string;
  yAxisKey: string;
}

const BarGraph: React.FC<BarGraphProps> = ({ content, xAxisKey, yAxisKey }) => {
  const theme = useTheme();
  const colorPalette = [theme.palette.primary.main, ...defaultColorPalette];

  const { xLabel, yLabel, abbreviatedContent, series } = getCartesianChartData(
    content,
    xAxisKey,
    colorPalette,
    yAxisKey,
  );

  const marginLeft = useMediaQuery(theme.breakpoints.up("sm")) ? 100 : 60;

  return (
    <BarChart
      dataset={abbreviatedContent}
      xAxis={[{ scaleType: "band", dataKey: xAxisKey, label: xLabel }]}
      series={series}
      yAxis={[{ label: yLabel }]}
      height={350}
      width={700}
      margin={{ left: marginLeft, top: 30, bottom: 50 }}
      {...cartesianChartStyling}
    />
  );
};

export const validateBarGraph = (data: any[], xAxis?: string): boolean => {
  if (!Array.isArray(data) || data.length === 0) return false;
  if (typeof data[0] !== "object") return false;
  const keys = Object.keys(data[0]);
  return xAxis !== undefined && keys.includes(xAxis);
};

export default BarGraph;
